import { useMemo } from 'react'

// eslint-disable-next-line react-hooks/exhaustive-deps, react-hooks-js/use-memo
export const useImmutableValue = <T>(init: () => T) => useMemo(init, [])
